import { useMediaQuery } from '@mui/material';
import { BoxComponent } from '../../../../../base/box/Box';

interface OutOfStockProps {
  fontFamily?: string;
}

const OutOfStock = ({ fontFamily = 'sans-serif' }: OutOfStockProps) => {
  const isSmallScreen = useMediaQuery('(min-width:1920px)');
  const isLargeScreen = useMediaQuery('(min-width:3840px)');

  return (
    <BoxComponent
      sx={{
        fontSize: '6px',
        height: '11px',
        lineHeight: '11px',
        backgroundColor: '#FF7171',
        color: '#242528',
        fontWeight: '400',
        textAlign: 'center',
        borderRadius: '20px',
        paddingX: '4px',
        fontFamily: fontFamily,
        ...(isSmallScreen ? { fontSize: '12px', height: '22px', lineHeight: '22px' } : {}),
        ...(isLargeScreen ? { fontSize: '24px', height: '44px', lineHeight: '44px' } : {}),
      }}
    >
      Out of stock
    </BoxComponent>
  );
};

export default OutOfStock;
